import styled, { css } from 'styled-components'

interface ButtonProps {
  className?: string
  size?: 'small'
  variant: 'Primary' | 'Secondary'
}

export const StyledButton = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 500;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0.42px;
  transition: background-color 0.2s;
  gap: 8px;
  padding: 19px 24px;
`

export const StyledActionButton = styled(StyledButton)`
  ${({ theme, variant }) => {
    switch (variant) {
      case 'Primary':
        return css`
          color: ${theme.colors.primary.text};
          background-color: ${theme.colors.primary.main};
          border: 1px solid ${theme.colors.primary.main};

          &:hover {
            background-color: ${theme.colors.primary.hover};
          }
          &:active {
            background-color: ${theme.colors.primary.active};
          }
        `

      case 'Secondary':
        return css`
          color: ${theme.colors.secondary.text};
          border: 1px solid ${theme.colors.secondary.border};
          background-color: ${theme.colors.secondary.main};

          &:hover {
            background-color: ${theme.colors.secondary.hover};
          }
          &:active {
            background-color: ${theme.colors.secondary.active};
          }
        `
    }
  }};
  ${({ disabled, theme }) =>
    disabled &&
    css`
      color: ${theme.colors.disabled.text};
      background-color: ${theme.colors.disabled.main};
      border: 1px solid ${theme.colors.disabled.main};
      cursor: default;
      pointer-events: none;
    `};
`

export const StyledLinkButton = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.42px;
  transition: background-color 0.2s;
  gap: 8px;
  border-bottom-style: solid;
  border-bottom-width: 1px;

  ${({ disabled }) =>
    disabled &&
    `

       opacity: 0.5;
       cursor: default;
       pointer-events: none;
 
`};

  ${(props) => {
    switch (props.variant) {
      case 'Primary':
        return css`
          color: ${props.theme.colors.primary.main};
          border-bottom-color: ${props.theme.colors.primary.main};

          &:hover {
            color: ${props.theme.colors.primary.hover};
            border-bottom-color: ${props.theme.colors.primary.hover};
          }
        `

      case 'Secondary':
        return css`
          color: ${props.theme.colors.secondary.main};
          border-bottom-color: ${props.theme.colors.secondary.main};

          &:hover {
            color: ${props.theme.colors.secondary.hover};
            border-bottom-color: ${props.theme.colors.secondary.hover};
          }
        `
    }
  }};
`

export const ButtonsColumn = styled.div`
  display: flex;
  gap: 20px;
  flex-flow: column;
`
